import styled from 'styled-components';

export const OnboardingTutorialNavigationStyled = styled.div`
    display: flex;
    align-items: center;
    padding: 0 16px 16px;
`;

export const OnboardingTutorialNavigationPaginationStyled = styled.div`
    display: flex;
    padding: 18px 0;
`;

export const OnboardingTutorialNavigationMarkerStyled = styled.div`
    height: 4px;
    width: 4px;
    border-radius: 2px;
    background-color: var(--icon-primary-color);
    
    &.active {
        width: 12px;
    }
`;
